import Vue from "vue"
import AmplilyWidget from "./vov-widget.vue"
import { AwOptions } from "../models/AwOptions"
import state from "../mixins/state"
Vue.config.productionTip = false
;(window as any).setupAmplilyWidget = (options: AwOptions) => {
  var el = document.getElementsByClassName("parmonic-widget")[0]
  new Vue({
    mixins: [state],
    render: h => h(AmplilyWidget),
    created() {
      if (options && options.apiEndpoint)
        this.$data.baseurlAdminAppUrl = options.apiEndpoint + "/"
      if (options && options.dataEndpoint)
        this.$data.PublishedWebinarDataEndPoint = options.dataEndpoint + "/"
      if (options && options.initGating) this.$data.isGated = true
    },
    mounted() {
      this.$data.analyticsEventsCaptureEndPoint = `${this.$data.baseurlAdminAppUrl}api/v4/event`
      this.$data.socialShareUrl = this.$data.isLocalhost
        ? this.$data.localbase
        : "https://snackified.co/"
    }
  }).$mount(el!)
}
